import React from 'react';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

export default class TestingBanner extends React.Component {

    hideTestingBanner = (e) => {
        e.target.style.display = 'none';
    };

    render() {
        const showBanner = !config.isProduction && config.applicationEnv !== 'development';

        if (!showBanner) {
            return null;
        }

        return (
            <div className='website-for-testing-only' onClick={this.hideTestingBanner}>
                <img src={`${config.cdnUrl}/static/testing-only.png`} alt='Testing website' />

                <style global jsx>
                    {`
                        .website-for-testing-only {
                            position: fixed;
                            top: 0;
                            left: 140px;
                            cursor: pointer;
                            z-index: 30000;
                        }
                    `}
                </style>
            </div>
        );
    }
}
